import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader-firmar',
  templateUrl: './loader-firmar.component.html',
  styleUrls: ['./loader-firmar.component.scss'],
  host: { class: 'app-loader-firmar' }
})
export class LoaderFirmarComponent implements OnInit {

  @Input('disabled') disabled:boolean
  @Input('big') big:boolean
  @Input('no-bg') noBg:boolean

  constructor() { }

  ngOnInit(): void {
  }

}
